export const FETCH_STORE = 'storePage/FETCH_STORE';
